// Helpers sin JSX de la sección de saldos heredados. Ver el comentario de
// cabecera de `LegacyBalances.jsx` para qué es esta sección y por qué se lee
// distinta del resto de la página.

// El saldo heredado nombra su origen en el subtítulo del modal: abrir
// "Register payment" sobre Partners Edge sin ver de cuál de los dos Partners
// Edge se trata sería exactamente el equívoco que la sección intenta evitar.
export const legacySubtitle = (balance) =>
  `${balance.legacy_id} · carried over from ${balance.source}`

// La fecha de corte de UN lado (payables o receivables), calculada sobre las
// filas que esta página realmente enseña.
//
// El par `as_of`/`as_of_mixed` que trae el envelope no sirve desde que la
// página se partió en dos: el backend lo calcula sobre TODOS los saldos
// activos, los dos lados juntos (financial/aggregates.py, legacy_summary()
// arma `cut_offs` sobre `balances` sin filtrar por kind). Usarlo tal cual
// pintaría "Mixed cut-off dates" sobre unas tarjetas cuyas fechas sí
// coinciden, nada más porque el otro lado discrepa — un caption falso, que es
// justo lo que esta sección existe para evitar.
//
// No es una estimación de cliente: cada fila trae su propio `as_of`
// (aggregates.py, _legacy_row), así que esto es la misma regla del backend
// —la fecha más tardía presente, "mixed" si hay más de una— aplicada al
// subconjunto que corresponde. Por eso las páginas descartan `as_of` y
// `as_of_mixed` al leer la respuesta en vez de guardarlos: serían una segunda
// fuente de verdad que sólo puede desmentir a esta.
export const cutOffOf = (balances) => {
  // Las fechas son 'YYYY-MM-DD': el orden lexicográfico ES el cronológico, así
  // que esto equivale al max() del backend sin construir ningún Date (que
  // además retrocedería un día al oeste de UTC — la razón de ser de fmtDay).
  const cutOffs = [...new Set((balances || []).map((b) => b.as_of).filter(Boolean))].sort()
  return {
    asOf: cutOffs.length ? cutOffs[cutOffs.length - 1] : null,
    mixed: cutOffs.length > 1,
  }
}
